import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const TicketTableRow = ({
  id,
  ticketid,
  workflowtype,
  subject,
  status,
  assignedto,
  creationdate,
  lob,
  message,
  metadata,
  checkNumber,
  CheckType,
  checkAmount,
  displayStatus,
  docClass
}) => {
  return (
    <tr key={id}>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={ticketid}>
          {ticketid}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={workflowtype.replace("AARP", "")}>
          {metadata?.requestType || workflowtype.replace("AARP", "")}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={subject}>
          {subject}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={status}>
          {displayStatus}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={docClass}>
          {docClass}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={lob}>
          {lob}
        </p>
      </td>
      <td className="p-2">
        <p className="block font-18-400-24 text-black-4" title={moment.utc(creationdate).fromNow()}>
          {moment.utc(creationdate).utcOffset(-5).format("MMM D, YYYY h:mm A")}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={checkNumber}>
          {checkNumber}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={CheckType}>
          {CheckType}
        </p>
      </td>
      <td className="p-2">
        <p className="block truncated-text font-18-400-24 text-black-4" title={checkAmount}>
          {checkAmount}
        </p>
      </td>
      <td className="p-2">
        <p className="block font-18-400-24 text-black-4 truncated-text" title={message}>
          {message}
        </p>
      </td>
      <td className="p-1 text-center">
        <button className="border-none bg-transparent p-0" type="button">
          <Link to={`/manage-ticket/ticket/view/${id}`}>
            <img className="size-16" src="./read.svg" alt="View" />
          </Link>
        </button>
      </td>
      <td className="p-1 text-center">
        <button className="border-none bg-transparent p-0" type="button">
          <Link to={`/manage-ticket/ticket/edit/${id}`}>
            <img className="size-16" src="./edit.svg" alt="Edit" />
          </Link>
        </button>
      </td>
    </tr>
  );
};

export default TicketTableRow;
